import { darkmode } from "@components";
import { Show } from "solid-js";
import { css } from "styled-system/css";

export default function Logo(props: { isSmall?: boolean }) {
  return (
    <Show when={darkmode()} fallback={<img
      class={css({ height: props.isSmall ? '25px' : '40px', width: props.isSmall ? '25px' : '40px' })}
      src={'/logo.png'}
      alt="sniper circle logo"
    />}>
      <img
        class={css({ height: props.isSmall ? '25px' : '40px', width: props.isSmall ? '25px' : '40px' })}
        src={'/logo_dark.png'}
        alt="sniper circle logo"
      />
    </Show>
  )
}
